export default {
    namespaced: true,
    state: {
        obj: {},
        objs: [],
    },
    mutations: {
        setObjs(state, pload) {
            state.objs = pload
        },
        setObj(state, pload) {
            state.obj = pload
        },
    },
    actions: {
        getObjs({rootState, commit}, payload) {
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + `daily-check?date=${payload.date}&volume=${payload.volume}`
                this._vm.$axios.get(url, {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        commit('setObjs', response.data.data.data)
                        resolve(response)
                    }, error => {
                        reject(error)
                    })
            })
        },
        store({rootState}, payload) {
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + "daily-check";
                this._vm.$axios.post(url, JSON.stringify(payload), {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    });
            });
        },
        storeIseller({rootState}, payload) {
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + "daily-check/get-iseller";
                this._vm.$axios.post(url, JSON.stringify(payload), {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    });
            });
        },
    }
}